import { Component } from '@angular/core';
import { LegalLayoutComponent } from '../components/legal-layout.component';

@Component({
  selector: 'app-devoluciones',
  standalone: true,
  imports: [LegalLayoutComponent],
  templateUrl: './devoluciones.component.html',
  styleUrl: './devoluciones.component.css'
})
export class DevolucionesComponent {
  title = 'Política de Devoluciones';
  lastUpdated = '30 de octubre de 2025';
}

